const defaultMeta = {
  requiresAuth: true,
  requiresAdmin: false,
}

const userAccountRoute = {
  path: '/account',
  name: 'user-account',
  meta: defaultMeta,
  component: _ => import('@/views/User/UserAccountView.vue'),
  props: true,
  redirect: {
    name: 'user-account-profile',
  },
  children: [
    {
      path: 'profile',
      name: 'user-account-profile',
      meta: {
        ...defaultMeta,
        title: 'User Profile',
      },
      props: true,
      component: _ => import('@/components/UserAccount/UserProfile.vue'),
    },
    {
      path: 'contacts',
      name: 'user-account-contact-details',
      meta: {
        ...defaultMeta,
        title: 'Contact Details',
      },
      props: true,
      component: _ => import('@/components/UserAccount/ContactDetails.vue'),
    },
    {
      path: 'integrations',
      name: 'user-account-integration-settings',
      meta: {
        ...defaultMeta,
        title: 'Integration Settings',
      },
      props: true,
      component: _ => import('@/components/UserAccount/IntegrationSettings.vue'),
    },
    {
      path: 'security',
      name: 'user-account-security-settings',
      meta: {
        ...defaultMeta,
        title: 'Security Settings',
      },
      props: true,
      component: _ => import('@/components/UserAccount/SecuritySettings.vue'),
    },
  ],
}

const publicUserAccountRoute = {
  path: '/user/:userId',
  name: 'public-user-account',
  meta: {
    ...defaultMeta,
  },
  component: _ => import('@/views/User/UserPublicAccountView.vue'),
  props: true,
  redirect: {
    name: 'public-user-account-profile',
  },
  children: [
    {
      path: 'profile',
      name: 'public-user-account-profile',
      meta: {
        ...defaultMeta,
        title: 'User Profile',
        isReadOnly: true,
      },
      props: true,
      component: _ => import('@/components/UserAccount/UserProfile.vue'),
    },
    {
      path: 'contacts',
      name: 'public-user-account-contact-details',
      meta: {
        ...defaultMeta,
        title: 'Contact Details',
        isReadOnly: true,
      },
      props: true,
      component: _ => import('@/components/UserAccount/ContactDetails.vue'),
    },
    {
      path: 'memberships',
      name: 'public-user-account-memberships',
      meta: {
        ...defaultMeta,
        title: 'Team Memberships',
        isReadOnly: true,
      },
      props: true,
      component: _ => import('@/components/UserAccount/TeamMemberships.vue'),
    },
    {
      path: 'groups',
      name: 'public-user-account-groups',
      meta: {
        ...defaultMeta,
        title: 'Groups',
        isReadOnly: true,
      },
      props: true,
      component: _ => import('@/components/UserAccount/UserGroups.vue'),
    },
  ],
}

export default [userAccountRoute, publicUserAccountRoute]
